
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import { InputGroup, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import AppNavbar from "./AppNavbar"

const UserList = () => {
    const navigate = useNavigate();
    const [list, setList] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [searchTerms, setSearchTerms] = useState("");
    const [city, setCity] = useState("");
    const [device, setDevice] = useState("");

    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);
    const [filter, setFilter] = useState("");
    //const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        // Check if user is logged in and is admin
        const loginData = localStorage.getItem('login');
        if (loginData) {
            try {
                const user = JSON.parse(loginData);
                //  setUserRole(user.role);
                if (user.role !== 'admin') {
                    toast.error('Access denied. Admin only.');
                    navigate('/');
                }
            } catch (error) {
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        setDevice(isMobile);

    }, [navigate]);

    useEffect(() => {

        getData();

        const fetchData = async () => {
            try {

                const response = await fetch(
                    'https://hospital.rozeetechnist.com/hospital-api/getCities.php'
                );
                const result = await response.json();
                setDropdownOptions(result);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();

        setFilterOptions([
            { 'value': "all", "label": "All" },
            { 'value': "admin", "label": "Admin" },
            { 'value': "user", "label": "User" }
        ])

    }, [currentPage, itemsPerPage, searchTerms, city, filter]);


    const handleSelectChange = (selectedOption) => {
        setCity((prevData) => ({
            ...prevData,
            city: selectedOption, // Store only the value property
        }));
    };

    const handleFilterChange = (selectedOption) => {
        setFilter((prevData) => ({
            ...prevData,
            filter: selectedOption, // Store only the value property
        }));
    };

    const getData = () => {
        fetch(`https://hospital.rozeetechnist.com/hospital-api/getUsers.php`, {
            method: "Post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                start: currentPage,
                per_page: itemsPerPage,
                search: searchTerms,
                city: city,
                role: filter
            })
        })
            .then((response) => response.json())
            .then((result) => {
                setItemsPerPage(10);
                setTotalItems(result.total_records);
                setList(result.data);
            })
            .catch((error) => console.error('Error fetching data:', error));
    };

    const deleteItem = (id) => {
        const isConfirmed = window.confirm('Are you sure you want to delete this user?');

        if (isConfirmed) {
            fetch(`https://hospital.rozeetechnist.com/hospital-api/deleteUser.php`, {
                method: "Delete",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: id
                })
            })
                .then((result) => result.json())
                .then((resp) => {
                    if (resp.status) {
                        getData();
                        toast.success(resp.message);
                    } else {
                        toast.error(resp.message);
                    }
                })
                .catch((error) => console.error('Error deleting user:', error));
        }
    };

    const toggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        fetch(`https://hospital.rozeetechnist.com/hospital-api/updateUserStatus.php`, {
            method: "Post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: id,
                status: newStatus
            })
        })
            .then((result) => result.json())
            .then((resp) => {
                if (resp.status) {
                    getData();
                    toast.success(resp.message);
                } else {
                    toast.error(resp.message);
                }
            })
            .catch((error) => console.error('Error updating status:', error));
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // const exportReport = () => {
    // // Replace 'your-api-endpoint' with the actual server-side pagination endpoint
    //     fetch(`https://hospital.rozeetechnist.com/hospital-api/exportReport.php`, {
    //         method: "Post",
    //         headers: {
    //             "Content-Type": "application/json"
    //         },
    //         body: JSON.stringify({
    //             search: searchTerms,
    //             city: city,
    //             filter:filter
    //         })
    //     })
    //     .then((response) => response.json())
    //     .then((result) => {
    //         console.warn(result);
    //     })
    //     .catch((error) => console.error('Error fetching data:', error));
    // };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const getPaginationItems = () => {
        const pageNumbers = [];
        let startPage = currentPage - 2;
        let endPage = currentPage + 2;

        if (startPage <= 0) {
            startPage = 1;
            endPage = 5;
        }

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - 4;
            if (startPage <= 0) {
                startPage = 1;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <Pagination.Item key={i} active={i === currentPage} onClick={() => paginate(i)}>
                    {i}
                </Pagination.Item>
            );
        }

        return pageNumbers;
    };

    return (
        <div>
            <AppNavbar />

            <section className="wrapper">

                <div className="container">
                    <div className="row top-page-bar">
                        <div className="col-md-4">
                            <div className="main-title">
                                <h1>Users Management</h1>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="search-area">
                                <InputGroup>
                                    <FormControl
                                        placeholder="Search by name or mobile"
                                        aria-label="Search term"
                                        aria-describedby="basic-addon2"
                                        onChange={(e) => setSearchTerms(e.target.value)}
                                    />
                                    <InputGroup.Text></InputGroup.Text>
                                    <Select
                                        name="city"
                                        onChange={handleSelectChange}
                                        options={dropdownOptions}
                                        placeholder="City"
                                        isClearable
                                    />
                                    <InputGroup.Text></InputGroup.Text>
                                    <Select
                                        name="filter"
                                        onChange={handleFilterChange}
                                        options={filterOptions}
                                        placeholder="Role"
                                        isClearable
                                    />
                                    {/* <div className="buttons filters">
                                        <Link to="/user-create" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faPlus} /> Add User
                                        </Link>
                                    </div> */}
                                </InputGroup>

                            </div>
                        </div>
                    </div>
                </div>

                <main className="container">
                    {list ? (
                        <>
                            {device ? (
                                <div>
                                    <div className='mobile_view'>
                                        {list.map((item) => (
                                            <div key={item.id}>
                                                <div className='row box'>
                                                    <div className="col-md-12">
                                                        <span className="r-value receipt_name">Name : {item.name}</span>
                                                    </div>
                                                    <div className="col">
                                                        <span className="r-label">Mobile : </span>
                                                        <span className="r-value">{item.mobile_number}</span>
                                                    </div>
                                                    <div className="col">
                                                        <span className="r-label">City :</span>
                                                        <span className="r-value">{item.city_name || 'N/A'}</span>
                                                    </div>
                                                    <div className="col">
                                                        <span className="r-label">Role :</span>
                                                        <span className="r-value typeofdonation">{item.role}</span>
                                                    </div>
                                                    <div className="col">
                                                        <span className="r-label">Status :</span>
                                                        <span className="r-value">{item.status === 1 ? 'Active' : 'Inactive'}</span>
                                                    </div>
                                                    <div className="mt-3"></div>
                                                    <div className="col-md-12 table-buttons">
                                                        <span className="editbtn"><Link to={`/user-update/${item.id}`}>
                                                            Edit
                                                        </Link></span>
                                                        <span className="deletebtn" onClick={() => deleteItem(item.id)}>
                                                            Delete
                                                        </span>
                                                        <span
                                                            className="printbtn"
                                                            onClick={() => toggleStatus(item.id, item.status)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {item.status === 1 ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Mobile Number</th>
                                                <th>City</th>
                                                <th>Role</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.name}</td>
                                                    <td>{item.mobile_number}</td>
                                                    <td>{item.city_name || 'N/A'}</td>
                                                    <td>{item.role}</td>
                                                    <td>
                                                        <span
                                                            onClick={() => toggleStatus(item.id, item.status)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {item.status === 1 ? (
                                                                <FontAwesomeIcon icon={faToggleOn} color="green" size="lg" />
                                                            ) : (
                                                                <FontAwesomeIcon icon={faToggleOff} color="grey" size="lg" />
                                                            )}
                                                        </span>
                                                        <span style={{ marginLeft: '8px' }}>
                                                            {item.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </td>
                                                    <td className="table-action">
                                                        <span><Link to={`/user-update/${item.id}`}>
                                                            <FontAwesomeIcon icon={faEdit} color="green" />
                                                        </Link></span>
                                                        <span onClick={() => deleteItem(item.id)}>
                                                            <FontAwesomeIcon icon={faTrash} color="red" />
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                </>
                            )}
                        </>
                    ) : (
                        <p>No data found</p>
                    )}
                    <Pagination>
                        <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
                        {getPaginationItems()}
                        <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
                    </Pagination>
                    <div className="createButton">
                        <Link to="/user-create">
                            <FontAwesomeIcon icon={faPlus} />
                        </Link>
                    </div>
                </main>
            </section>
        </div>
    );
};

export default UserList;
